import React from 'react';
import '../../styles/hostel.css';

const Transport = () => {
  return (
    <div className="about-container1">
      
      {/* Boys Hostel Section */}
      <div className="hostel-section">
        <h1 className="hostel-heading">OUR BOYS HOSTEL</h1>
        <div className="yellow-dashed-line"></div>
        <div className="hostel-content">
          <div className="hostel-description">
            <p>
              Separate hostel facilities are available for boys and girls within the campus.
              Each building is well furnished and has adequate toilets, dining hall, hi-tech kitchens, and balconies.
              Well furnished and spacious rooms.
              Recreation and indoor games facility.
              Professionally managed caterers provide healthy, hygienic, and tasty food.
              Staff wardens and resident wardens monitor the students.
              Round the clock security and surveillance cameras to ensure safety.
              A mini library and reading rooms.
              Prayer Hall.
              General store which stocks all basic items for students.
              Uninterrupted water and power supply.
              Medical facility provided to sick students.
            </p>
          </div>
          <div className="hostel-image">
            <img src="/images/hostel2.jpg" alt="Boys Hostel" />
          </div>
        </div>
      </div>

      {/* Girls Hostel Section */}
      <div className="hostel-section">
        <h1 className="hostel-heading">OUR LADIES HOSTEL</h1>
        <div className="yellow-dashed-line"></div>
        <div className="hostel-content">
          <div className="hostel-description">
            <p>
              The Ladies Hostel at PA Polytechnic College provides a safe, comfortable, and homely environment for female students. The hostel is well-furnished with spacious rooms designed for a convenient and disciplined lifestyle. Each room is equipped with study tables, wardrobes, comfortable bedding, and proper ventilation to ensure a pleasant stay.
              
              To enhance the living experience, the hostel includes modern amenities such as 24/7 security surveillance, high-speed Wi-Fi, and uninterrupted power and water supply. A dedicated warden and staff ensure the safety and well-being of all residents.
              <br /><br />
              The hostel features a spacious dining hall where nutritious and hygienic meals are prepared by professional caterers. Other facilities include a recreation area, reading room, prayer hall, medical assistance, and a mini store that provides essential items for students.
            
              With a focus on safety, cleanliness, and student welfare, the Ladies Hostel at PA Polytechnic College offers a peaceful and enriching residential experience for young women pursuing their education.
            </p>
          </div>
          <div className="hostel-image">
            <img src="/images/ladies.jpg" alt="Girls Hostel" />
          </div>
        </div>
      </div>

    </div>
  );
};

export default Transport;
